export default __webpack_public_path__ + "static/media/Stalker's Belt of the Black Arts.7fd8fb9d.jpg";